

window.console = window.console || { log: function () { } };
var csrfCode = '';

var isObject = function(obj) {
  return obj === Object(obj);
};

/**
 * 工具类
 * @class util
 * @static
 */
var util = {
  changeLetterCase: function (obj, type, notChangeAllUppercaseFeild) {
    var isObject = function (obj) {
      return obj === Object(obj);
    };
    var _self = this;
    if (Array.isArray(obj)) {
      obj.forEach(function (item, i, arr) {
        if (isObject(item) || Array.isArray(item)) {
          arr[i] = _self.changeLetterCase(
            item,
            type,
            notChangeAllUppercaseFeild
          );
        }
      });
    } else if (isObject(obj)) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          var newProp = prop;
          if (
            !notChangeAllUppercaseFeild ||
            (notChangeAllUppercaseFeild && !/^[A-Z]+$/g.test(prop))
          ) {
            var firstLetter = prop.substr(0, 1);
            newProp =
              (type === "upper"
                ? firstLetter.toUpperCase()
                : firstLetter.toLowerCase()) + prop.slice(1);
          }
          if (newProp !== prop) {
            obj[newProp] = JSON.parse(JSON.stringify(obj[prop]));
            delete obj[prop];
          }
          if (isObject(obj[newProp]) || Array.isArray(obj[newProp])) {
            obj[newProp] = _self.changeLetterCase(
              obj[newProp],
              type,
              notChangeAllUppercaseFeild
            );
          }
        }
      }
    }

    return obj;
  },
  toUpperCaseFL: function(obj) {
    return this.changeLetterCase(obj, 'upper')
  },
  toLowerCaseFL: function(obj) {
    return this.changeLetterCase(obj, 'lower', true)
  },
  revertResp: function (resp) {
    let code, message;
    if(resp && resp.code === 0) {
      const data = resp.data;
      // 云 api V3 接口的 code 和 message 包装在 Response 的 Error 对象中
      if (data.Response && data.code === undefined) {
        let error = data.Response.Error || {}
        message = error.Message
        code = error.Code || 0
      } else {
        code = data.code
        message = data.message
      }

      let result = {
        data,
        message,
        code
      }

      var codeReg = /^\((\d+)\).+$/
      if (codeReg.test(data.message)) {
        result.cgwCode = +RegExp.$1 // 解析 cgw 错误码
      }
      return result
    }
    return resp;
  },
  cookie: {
    /**
     * 获取cookie
     * @method get
     * @param  {String} name 名称
     * @return {String} 
     */
    get: function (name) {
      var r = new RegExp("(?:^|;+|\\s+)" + name + "=([^;]*)"),
        m = document.cookie.match(r);

      return !m ? "" : m[1];
    },
    /**
     * 设置cookie
     * @method set
     * @param {String} name 名称
     * @param {String} value 值
     * @param {String} domain 域
     * @param {String} path 路径
     * @param {String} hour 过期时间(小时)
     */
    set: function (name, value, domain, path, hour) {
      if (hour) {
        var expire = new Date();
        expire.setTime(expire.getTime() + 36E5 * hour);
      }
      document.cookie = name + "=" + value + "; " + (hour ? "expires=" + expire.toGMTString() + "; " : "") +
        (path ? "path=" + path + "; " : "path=/; ") + (domain ? "domain=" + domain + ";" : "domain=" + document.domain + ";");

      return true;
    },

    /**
     * 设置cookie（包含 secure）
     * @method setSecure
     * @param {String} name 名称
     * @param {String} value 值
     * @param {String} domain 域
     * @param {String} path 路径
     * @param {String} hour 过期时间(小时)
     */
    setSecure: function (name, value, domain, path, hour) {
      if (hour) {
        var expire = new Date();
        expire.setTime(expire.getTime() + 36E5 * hour);
      }
      document.cookie = name + "=" + value + "; " + (hour ? "expires=" + expire.toGMTString() + "; " : "") +
        (path ? "path=" + path + "; " : "path=/; ") + (domain ? "domain=" + domain + "; secure" : "domain=" + document.domain + "; secure");

      return true;
    },

    /**
     * 删除cookie
     * @method del
     * @param {String} name 名称
     * @param {String} domain 域
     * @param {String} path 路径
     */
    del: function (name, domain, path) {
      document.cookie = name + "=; expires=Mon, 26 Jul 1997 05:00:00 GMT; " +
        (path ? "path=" + path + "; " : "path=/; ") +
        (domain ? "domain=" + domain + ";" : "domain=" + document.domain + ";");
    }
  },

  /**
   * html模板生成器, =号转义, -号原始输出
   * @method tmpl
   * @param  {String} str html模板字符串 | script模版元素Id
   * @param  {Object} data 用于生成模板的数据对象
   * @param  {Object} [mixinTmpl] 混合模版对象
   * @return {String} 返回 html 字符串
   * @author evanyuan
   * @example 
   *		var careerTmpl = '<div><%=career%></div>';
   * 		util.tmpl('<h1><%=user%></h1> <%#careerTmpl%>', {user:'evanyuan', career: '前端工程师'}, {careerTmpl: careerTmpl});
   */
  tmpl: function () {
    var _cache = {},
      _escape = function (str) {
        if (str == 0) {
          return str;
        }
        str = (str || '').toString();
        return str.replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;');
      },
      _getTmplStr = function (rawStr, mixinTmpl) {
        if (mixinTmpl) {
          for (var p in mixinTmpl) {
            var r = new RegExp('<%#\\s?' + p + '%>', 'g');
            rawStr = rawStr.replace(r, mixinTmpl[p]);
          }
        }
        return rawStr;
      };

    return function tmpl(str, data, mixinTmpl) {
      var strIsKey = !/\W/.test(str);
      !strIsKey && (str = _getTmplStr(str, mixinTmpl));

      var fn = strIsKey ? _cache[str] = _cache[str] || tmpl(_getTmplStr(document.getElementById(str).innerHTML, mixinTmpl)) :
        new Function("obj", "_escape", "var _p='';with(obj){_p+='" + str
          .replace(/[\r\t\n]/g, " ")
          .split("\\'").join("\\\\'")
          .split("'").join("\\'")
          .split("<%").join("\t")
          .replace(/\t-(.*?)%>/g, "'+$1+'")
          .replace(/\t=(.*?)%>/g, "'+_escape($1)+'")
          .split("\t").join("';")
          .split("%>").join("_p+='")
          + "';} return _p;");

      var render = function (data) {
        if (typeof data == 'object') {
          data.QCCONSOLE_HOST = window.QCCONSOLE_HOST;
          data.QCMAIN_HOST = window.QCMAIN_HOST;
          data.QCBUY_HOST = window.QCBUY_HOST;
        }
        return fn(data, _escape)
      };

      return data ? render(data) : render;
    };
  }(),

  /**
   * 获取防CSRF串
   * @method getACSRFToken
   * @return {String} 验证串
   */
  getACSRFToken: function () {
    return window.tcesdk.security.getCSRFToken();
  },

  /**
   * 获取uin
   * @method getUin
   * @return {String} uin
   */
  getUin: function () {
    return parseInt(this.cookie.get("uin").replace(/\D/g, ""), 10) || '';
  },

  /**
   * 获取 ownerUin
   */
  getOwnerUin: function () {
    return parseInt(this.cookie.get("ownerUin").replace(/\D/g, ""), 10) || ''
  },

  /**
   * 获取 skey
   */
  getSessionKey: function () {
    var skey = this.cookie.get('skey') || this.cookie.get('p_skey');
    return skey ? decodeURIComponent(skey) : null;
  },

  setACSRFToken: function (token) {
    csrfCode = token;
  },

  /** XSS 转义**/
  escHTML: function (str) {
    if (str == 0) {
      return str;
    }
    str = (str || '').toString();
    return str.replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;');
  },

  /**
   * 将 URL 参数格式转化成对象
   * @method paramsToObject
   * @param  {String} [queryString] 要转换的 key-value 字符串，默认为 location.search
   * @return {Object}
   * @author evanyuan
   */
  paramsToObject: function (queryString) {
    var _result = {}, _pairs, _pair, _query, _key, _value;

    if (typeof (queryString) === 'object') { return queryString; }

    _query = queryString || window.location.search;
    _query = _query.replace('?', '');
    _pairs = _query.split('&');

    $(_pairs).each(function (i, keyVal) {
      _pair = keyVal.split('=');
      _key = _pair[0];
      _value = _pair.slice(1).join('=');
      _result[decodeURIComponent(_key)] = decodeURIComponent(_value);
    });

    return _result;
  },

  /**
   * JSON对象转url字符串
   * @method objectToParams
   * @param  {Object} obj JSON对象
   * @param  {Boolean} decodeUri url解码
   * @return {String} url字符串
   * @author evanyuan
   */
  objectToParams: function (obj, decodeUri) {
    var param = $.param(obj);
    if (decodeUri) {
      param = decodeURIComponent(param);
    }
    return param;
  },

  /**
   * 是否移动手机
   * @method isMobile
   * @return {boolean} true|false
   */
  isMobile: function () {
    return this.isAndroid() || this.isIOS();
  },

  /**
   * 是否android
   * @method isAndroid
   * @return {boolean} true|false
   */
  isAndroid: function () {
    return /android/i.test(window.navigator.userAgent);

  },

  /**
   * 是否ios
   * @method isIOS
   * @return {boolean} true|false
   */
  isIOS: function () {
    return /iPod|iPad|iPhone/i.test(window.navigator.userAgent)
  },

  /**
   * 获取a标签href相对地址
   * @method getHref
   * @param  {Object} item dom节点
   * @return {String} href
   * @author evanyuan
   */
  getHref: function (item) {
    var href = item.getAttribute('href', 2);
    var replaceStr = location.protocol + '//' + location.host;
    if (href.indexOf('//') == 0) {  //如果是 //console.qcloud.com/cvm 这种不带协议格式
      replaceStr = '//' + location.host;
    }
    href = href.replace(replaceStr, '');
    return href;
  },

  /**
   * 深度拷贝对象
   * @method cloneObject
   * @param  {Object} obj 任意对象
   * @param  {Object} [options] 其他选项
   * @return {Object} 返回新的拷贝对象
   * @author evanyuan
   */
  cloneObject: function (obj, options) {
    var o = obj.constructor === Array ? [] : {};
    for (var i in obj) {
      if (options && options.ignore && options.ignore.indexOf(i) >= 0) {
        continue;
      }
      if (obj.hasOwnProperty(i)) {
        o[i] = (obj[i] && (typeof obj[i] === "object")) ? this.cloneObject(obj[i]) : obj[i];
      }
    }
    return o;
  },

  /**
   * 插入内部样式
   * @method insertStyle
   * @param  {string | Array} rules 样式
   * @param  {string} id 样式节点Id
   * @author evanyuan
   */
  insertStyle: function (rules, id) {
    var _insertStyle = function () {
      var doc = document,
        node = doc.createElement("style");
      node.type = 'text/css';
      id && (node.id = id);
      document.getElementsByTagName("head")[0].appendChild(node);
      if (rules) {
        if (typeof (rules) === 'object') {
          rules = rules.join('');
        }
        if (node.styleSheet) {
          node.styleSheet.cssText = rules;
        } else {
          node.appendChild(document.createTextNode(rules));
        }
      }
    };
    if (id) {
      !document.getElementById(id) && _insertStyle();
    } else {
      _insertStyle();
    }
  },

  /**
   * 检测浏览器是否支持css3 animation属性
   * @method supportCss3Animation
   * @return {Boolean} 
   * @author evanyuan
   */
  supportCss3Animation: function () {
    var element = document.createElement('div');
    if ('animation' in element.style || 'webkitAnimation' in element.style) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 动画结束后回调
   * @method animationend
   * @param  {Object} el dom元素
   * @param  {Function} endCb 回调
   * @author evanyuan
   */
  animationend: function (el, endCb) {
    if (this.supportCss3Animation()) {
      var $el = $(el);
      var removeEvt = function () {
        var _cb = $el.data('cb');
        el.removeEventListener("animationend", _cb);
        el.removeEventListener("webkitAnimationEnd", _cb);
      };
      var cb = function () {
        endCb && endCb();
        removeEvt();
      };
      removeEvt();
      el.addEventListener("webkitAnimationEnd", cb);
      el.addEventListener("animationend", cb);
      $el.data('cb', cb);
    } else {
      if (endCb) {
        // IE9 模拟一个动画进程，否则某些异步过程会失序
        setTimeout(endCb, 1);
      }
    }
  },

  /**
   * requestAnimationFrame
   * @method requestAnimationFrame
   * @param  {Function} callback 回调
   * @author evanyuan
   */
  requestAnimationFrame: function (callback) {
    var _requestAnimationFrame = window.requestAnimationFrame
      || window.webkitRequestAnimationFrame
      || window.mozRequestAnimationFrame
      || function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    _requestAnimationFrame(callback);
  },

  /**
   * 检测浏览器是否支持css3 transform属性
   * @method supportTransform
   * @return {Boolean} 
   * @author evanyuan
   */
  supportTransform: function () {
    var element = document.createElement('div'),
      style = element.style;
    if ('WebkitTransform' in style || 'MozTransform' in style || 'OTransform' in style
      || 'Transform' in style || 'transform' in style) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 检测浏览器是否支持css3 transition属性
   * @method supportTransition
   * @return {Boolean} 
   * @author evanyuan
   */
  supportTransition: function () {
    var element = document.createElement('div'),
      style = element.style;
    if ('transition' in style || 'WebkitTransition' in style || 'MozTransition' in style
      || 'MsTransition' in style || 'OTransition' in style) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 为元素设置transform与transition
   * @method setTransformTransitionForElem
   * @param  {Object} elem dom元素
   * @param  {String} transform transform值
   * @param  {String} transition transition值
   * @author brianlin
   */
  setTransformTransitionForElem: function (elem, transform, transition) {
    if (!elem) {
      return
    }
    if (transform !== undefined) {
      elem.style.WebkitTransform = transform;
      elem.style.MozTransform = transform;
      elem.style.OTransform = transform;
      elem.style.msTransform = transform;
      elem.style.Transform = transform;
      elem.style.transform = transform;
    }
    if (transition !== undefined) {
      elem.style.WebkitTransition = transition;
      elem.style.MozTransition = transition;
      elem.style.OTransition = transition;
      elem.style.msTransition = transition;
      elem.style.Transition = transition;
      elem.style.transition = transition;
    }
  },

  classnames: (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    return classNames;
  })(),

  date: {
    /**
     * 格式化日期文本为日期对象
     *
     * @method str2Date         
     * @param {String} date 文本日期
     * @param {String} [p:%Y-%M-%d %h:%m:%s] 文本日期的格式
     * @return {Date}
     */
    str2Date: function (date, p) {
      // add 20171225
      // 针对"2021-01-10T08:39:48Z"格式日期预处理
      date = date.replace(/[TZ]/gi, ' ').replace(/\s+$/, '')
      p = p || '%Y-%M-%d %h:%m:%s';
      p = p.replace(/\-/g, '\\-');
      p = p.replace(/\|/g, '\\|');
      p = p.replace(/\./g, '\\.');
      p = p.replace('%Y', '(\\d{4})');
      p = p.replace('%M', '(\\d{1,2})');
      p = p.replace('%d', '(\\d{1,2})');
      p = p.replace('%h', '(\\d{1,2})');
      p = p.replace('%m', '(\\d{1,2})');
      p = p.replace('%s', '(\\d{1,2})');

      var regExp = new RegExp('^' + p + '$'),
        group = regExp.exec(date),
        Y = (group[1] || 0) - 0,
        M = (group[2] || 1) - 1,
        d = (group[3] || 0) - 0,
        h = (group[4] || 0) - 0,
        m = (group[5] || 0) - 0,
        s = (group[6] || 0) - 0;

      return new Date(Y, M, d, h, m, s);
    },

    /**
     * 格式化日期为指定的格式
     *
     * @method date2Str
     * @param {Date} date
     * @param {String} p 输出格式, %Y/%M/%d/%h/%m/%s的组合
     * @param {Boolean} [isFill:false] 不足两位是否补0
     * @return {String}
     */
    date2Str: function (date, p, isFill) {
      var Y = date.getFullYear(),
        M = date.getMonth() + 1,
        d = date.getDate(),
        h = date.getHours(),
        m = date.getMinutes(),
        s = date.getSeconds();

      if (isFill) {
        M = (M < 10) ? ('0' + M) : M;
        d = (d < 10) ? ('0' + d) : d;
        h = (h < 10) ? ('0' + h) : h;
        m = (m < 10) ? ('0' + m) : m;
        s = (s < 10) ? ('0' + s) : s;
      }
      p = p || '%Y-%M-%d %h:%m:%s';
      p = p.replace(/%Y/g, Y).replace(/%M/g, M).replace(/%d/g, d).replace(/%h/g, h).replace(/%m/g, m).replace(/%s/g, s);
      return p;
    },

    /**
     * 日期比较(d1 - d2)
     *
     * @method dateDiff
     * @param {Date} d1
     * @param {Date} d2
     * @param {String} [cmpType:ms] 比较类型, 可选值: Y/M/d/h/m/s/ms -> 年/月/日/时/分/妙/毫秒
     * @return {Float}
     */
    dateDiff: function (d1, d2, cmpType) {
      var diff = 0;
      switch (cmpType) {
        case 'Y':
          diff = d1.getFullYear() - d2.getFullYear();
          break;
        case 'M':
          diff = (d1.getFullYear() - d2.getFullYear()) * 12 + (d1.getMonth() - d2.getMonth());
          break;
        case 'd':
          diff = (d1 - d2) / 86400000;
          break;
        case 'h':
          diff = (d1 - d2) / 3600000;
          break;
        case 'm':
          diff = (d1 - d2) / 60000;
          break;
        case 's':
          diff = (d1 - d2) / 1000;
          break;
        default:
          diff = d1 - d2;
          break;
      }
      return diff;
    },
    /**
     * 日期相加
     *
     * @method dateAdd
     * @param char interval 间隔参数
     *        y 年
     *        q 季度
     *        n 月
     *        d 日
     *        w 周
     *        h 小时
     *        m 分钟
     *        s 秒
     *        i 毫秒
     * @param {Date} indate 输入的日期
     * @param {Number} offset 差值
     * @return {Date} date 相加后的日期
     */
    dateAdd: function (interval, indate, offset) {
      switch (interval) {
        case 'y':
          indate.setFullYear(indate.getFullYear() + offset);
          break;
        case 'q':
          indate.setMonth(indate.getMonth() + (offset * 3));
          break;
        case 'n':
          indate.setMonth(indate.getMonth() + offset);
          break;
        case 'd':
          indate.setDate(indate.getDate() + offset);
          break;
        case 'w':
          indate.setDate(indate.getDate() + (offset * 7));
          break;
        case 'h':
          indate.setHours(indate.getHours() + offset);
          break;
        case 'm':
          indate.setMinutes(indate.getMinutes() + offset);
          break;
        case 's':
          indate.setSeconds(indate.getSeconds() + offset);
          break;
        case 'i':
          indate.setMilliseconds(indate.getMilliseconds() + offset);
          break;
        default:
          indate.setMilliseconds(indate.getMilliseconds() + offset);
          break;
      }
      return indate;
    },
    /**
    * 判断是否是闰年
    *
    * @method leapYear
    * @param {Date} indate 输入的日期
    * @return {Object} 对象(是否是闰年，各月份的天数集，当前月的天数)
    */
    leapYear: function (indate) {
      var _days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      var _is = false;
      var _d = 365;

      if ((indate.getFullYear() % 4 === 0 && indate.getFullYear() % 100 !== 0) || indate.getFullYear() % 400 === 0) {
        _days.splice(1, 1, 29);
        _is = true;
        _d = 366;
      } else {
        _days.splice(1, 1, 28);
        _is = false;
        _d = 365;
      }
      return { isLeapYear: _is, days: _days, yearDays: _d, monthDays: _days[indate.getMonth()] };
    },
    /**
     * 转换日期格式
     */
    parseDate: function (str, type) {
      if (!str) {
        return '';
      }
      var date = null, newStr;
      if (str instanceof Date) {
        date = str;
      } else {
        date = this.str2Date(str);
      }
      if (isNaN(date)) {
        return str;
      }
      var year = date.getFullYear();

      var month = date.getMonth() + 1;
      month = month >= 10 ? month : "0" + month;

      var day = date.getDate();
      day = day >= 10 ? day : "0" + day;

      var hour = date.getHours();
      hour = hour >= 10 ? hour : "0" + hour;

      var minute = date.getMinutes();
      minute = minute >= 10 ? minute : "0" + minute;

      var second = date.getSeconds();
      second = second >= 10 ? second : "0" + second;

      switch (type) {
        case "short": //短格式，如2011-05-06
          return year + "-" + month + "-" + day;
          break;
        case "long": //长格式，如2011-05-06 10:05:06
          return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + day;
          break;
        case "chinese": //中文格式，2011年05月06日 23:09
          return year + "年" + month + "月" + day + "日 " + hour + ":" + minute;
          break;
        case "monthday":
          return month + "月" + day + "日 " + hour + ":" + minute;
          break;
        default:
          return str;
          break;
      }
    }
  }

};

export default util;

